var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgRfq = function SvgRfq(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 33 33",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.627 14.987a1.588 1.588 0 0 0-1.588 0L9.833 18.57a1.588 1.588 0 0 0-.794 1.375v7.166c0 .568.303 1.092.794 1.376l6.206 3.583a1.588 1.588 0 0 0 1.588 0l6.206-3.583c.492-.284.795-.808.795-1.376v-7.166c0-.567-.303-1.092-.795-1.375l-6.206-3.583Zm-.17 4.075a1.588 1.588 0 0 0-1.589 0l-2.529 1.46a1.588 1.588 0 0 0-.794 1.375v2.92c0 .568.303 1.092.794 1.376l2.53 1.46a1.588 1.588 0 0 0 1.587 0l2.53-1.46c.49-.284.793-.808.793-1.376v-2.92c0-.567-.302-1.092-.794-1.375l-2.529-1.46Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.45 12.72c-.488.279-1.088.279-1.576 0l-3.166-1.81a1.588 1.588 0 0 1-.8-1.378V7.757a1.588 1.588 0 0 1 2.376-1.379l1.59.908a1.588 1.588 0 0 0 1.576 0l1.59-.908a1.588 1.588 0 0 1 2.376 1.379v1.775c0 .57-.305 1.096-.8 1.379L17.45 12.72ZM17.308 4.434c-.41.183-.88.183-1.29 0l-.901-.4a.828.828 0 0 1 .672-1.513l.417.186c.29.129.623.129.913 0l.418-.186a.828.828 0 0 1 .672 1.513l-.901.4Z"
  })));
};

export default SvgRfq;